/**
 * 标签 表单验证规则
 * @author zjs
 * @time 2017-12-11
 */
export default {
    data () {
        // 非空的判断
        var isNoEmpty = (rule, value, callback) => {
            if (value === '' || value === undefined) {
                callback(new Error('请输入'))
            } else {
                callback()
            }
        }
        return {
            formRules: {
                'fenlei_id' : [{ validator: isNoEmpty,required: true, trigger: 'blur' }],
                'name': [{ required: true, trigger: 'blur' }],
                'batch_id': [{ validator: isNoEmpty, required: true, trigger: 'blur' }]
            }
        }
    }
}